import ReactAsyncSelect from 'react-select/async';

interface AsyncSelectProps {
  loadOptions: (inputValue: string) => Promise<{ label: string; value: any }[]>;
  value?: { label: string; value: any } | { label: string; value: any }[] | null;
  onChange: (value: any) => void;
  onChangeOption?: (option: any) => void;
  isMulti?: boolean;
  label?: string;
  containerClassName?: string;
  placeholder?: string;
  defaultOptions?: boolean | { label: string; value: any }[];
  isClearable?: boolean;
  isDisabled?: boolean;
  cacheOptions?: boolean;
  [key: string]: any;
}

const AsyncSelect = (props: AsyncSelectProps) => {
  const {
    loadOptions,
    value,
    onChange,
    onChangeOption,
    isMulti = false,
    label,
    containerClassName,
    defaultOptions = true,
    ...rest
  } = props;

  const handleChange = (selected: any) => {
    onChangeOption?.(selected);
    if (isMulti) {
      onChange(selected ? selected.map((item: any) => item.value) : []);
    } else {
      onChange(selected ? selected.value : null);
    }
  };

  return (
    <div className={containerClassName ?? 'mt-3 col-lg-4 col-md-6 mb-2'}>
      {label && (
        <label htmlFor="fname-field" className="form-label">
          {label}
        </label>
      )}
      <ReactAsyncSelect
        loadOptions={loadOptions}
        defaultOptions={defaultOptions}
        isMulti={isMulti}
        value={value ?? null}
        onChange={handleChange}
        styles={{
          menu: (base) => ({
            ...base,
            zIndex: 100
          })
        }}
        {...rest}
      />
    </div>
  );
};

export default AsyncSelect;
